/* eslint-disable import/no-unresolved */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from 'src/components/sharedComponents/CustomButtons/Button';

const AddToList = ({
  onChange,
  creatList,
  handleCreateList,
  onClose,
  openAddToList,
  loading,
}) => (
  <>
    <Dialog
      open={openAddToList}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <DialogTitle id="alert-dialog-title">Crea una nueva Lista</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Cree una nueva lista para posteriormente añadir a esta el video o los
          videos a analizar.
        </DialogContentText>
        <form onSubmit={handleCreateList} autoComplete="off">
          <div>
            <TextField
              fullWidth
              required
              id="nombre"
              value={creatList?.nombre || ''}
              onChange={(event) => onChange(event, 'nombre')}
              label="Nombre"
            />
          </div>
          <br />
          <div>
            <TextField
              fullWidth
              required
              id="descripción"
              value={creatList?.descripcion || ''}
              onChange={(event) => onChange(event, 'descripcion')}
              label="Descripción"
            />
          </div>
          <br />
          <DialogActions>
            {loading ? (
              <CircularProgress />
            ) : (
              <Button type="submit" color="warning">
                Guardar
              </Button>
            )}
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  </>
);

export default AddToList;
